/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsCustomConfigResource extends models.RecommendationBaseForFinopsCustomResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsCustomConfigResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsCustomConfigResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsCustomConfigResource>): RecommendationForFinopsCustomConfigResource {
        let obj = Object.assign(new RecommendationForFinopsCustomConfigResource(), model);
        RecommendationForFinopsCustomConfigResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsCustomConfigResource>): RecommendationForFinopsCustomConfigResource {
        if (!model) return null;
        return RecommendationForFinopsCustomConfigResource.newInstance(<RecommendationForFinopsCustomConfigResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsCustomConfigResource) {
        if (!obj) return;

        models.RecommendationForFinopsCustomConfigResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsCustomConfigResource): boolean {
        if (models.RecommendationBaseForFinopsCustomResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsCustomConfigResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
